export const SERVER_CREATE_RESET = 'SERVER_CREATE_RESET'
export const SERVER_CREATE_SET_CREATED = 'SERVER_CREATE_SET_CREATED'
export const SERVER_CREATE_SET_ERROR = 'SERVER_CREATE_SET_ERROR'
export const SERVER_CREATE_SET_VIOLATIONS = 'SERVER_CREATE_SET_VIOLATIONS'
export const SERVER_CREATE_TOGGLE_LOADING = 'SERVER_CREATE_TOGGLE_LOADING'
